import { popperGenerator } from './createPopper.js';
export { popperGenerator } from './createPopper.js';
import eventListeners from './modifiers/eventListeners.js';
export { default as eventListeners } from './modifiers/eventListeners.js';
import popperOffsets from './modifiers/popperOffsets.js';
export { default as popperOffsets } from './modifiers/popperOffsets.js';
import computeStyles from './modifiers/computeStyles.js';
export { default as computeStyles } from './modifiers/computeStyles.js';
import applyStyles from './modifiers/applyStyles.js';
export { default as applyStyles } from './modifiers/applyStyles.js';
import offset from './modifiers/offset.js';
export { default as offset } from './modifiers/offset.js';
import flip from './modifiers/flip.js';
export { default as flip } from './modifiers/flip.js';
import preventOverflow from './modifiers/preventOverflow.js';
export { default as preventOverflow } from './modifiers/preventOverflow.js';
import arrow from './modifiers/arrow.js';
export { default as arrow } from './modifiers/arrow.js';
import hide from './modifiers/hide.js';
export { default as hide } from './modifiers/hide.js';

var defaultModifiers = [eventListeners, popperOffsets, computeStyles, applyStyles, offset, flip, preventOverflow, arrow, hide];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

export { createPopper, defaultModifiers };
